import classNames from 'classnames'
import { useEffect, useState } from 'react'

import AsteriAd from '@/components/AsteriAd/AsteriAd'
import Leaderboard from '@/components/Layout/Leaderboard/Leaderboard'
import { useTheme } from '@/components/ThemeProvider/ThemeProvider'
import Twitch from '@/components/Twitch/Twitch'
import { useLoadAds } from '@/contexts/ads'
import useDirectories from '@/utils/useDirectories'

import styles from './Main.module.scss'

const LEADERBOARD_BLACKLIST = ['combo-vote']

const SIDEBAR_BLACKLIST = [
  'about-us',
  'account',
  'apply',
  'bug-report',
  'confirm-password',
  'contact-us',
  'forgot-password',
  'newsletter',
  'privacy',
  'reset-password',
  'signin',
  'signup',
]

type Props = {
  artCrop?: string
  banner?: React.ReactNode
  children: React.ReactNode
}

const GRADIENT_DARK = 'linear-gradient(to bottom, rgba(18, 19, 21, 0.5), rgba(18, 19, 21, 1))'
const GRADIENT_LIGHT = 'linear-gradient(to bottom, rgba(249, 250, 251, 0.5), rgba(249, 250, 251, 1))'

const asteriRegion = undefined

const twitchEnabled = false

const Main = ({ artCrop, banner, children }: Props) => {
  const { dir } = useDirectories()
  const loadAds = useLoadAds()
  const [theme] = useTheme()
  const [asteriEnabled, setAsteriEnabled] = useState(false)

  useEffect(() => {
    const fetchAsteriConfig = async () => {
      const res = await fetch('https://edhrec.com/articles/wp-json/wp/v2/pages?slug=z-asteri-v2')
      const data = await res.json()
      const { acf } = data[0]
      const asteriConfig = acf?.repeater.map(
        ({ group: { end, start } }: { group: { end: string; start: string } }) => ({
          end: new Date(end.replace(' ', 'T') + '-07:00'),
          start: new Date(start.replace(' ', 'T') + '-07:00'),
        }),
      )
      asteriConfig?.forEach(({ end, start }: { end: Date; start: Date }) => {
        const localStringConfig = {
          day: '2-digit',
          hour: 'numeric',
          hour12: true,
          minute: '2-digit',
          month: '2-digit',
          timeZone: 'America/Los_Angeles',
          year: 'numeric',
        } as Intl.DateTimeFormatOptions
        const startString = start.toLocaleString('en-US', localStringConfig).replace(', ', ' ') + ' PT'
        const endString = end.toLocaleString('en-US', localStringConfig).replace(', ', ' ') + ' PT'
        console.log(`Asteri: ${startString} => ${endString}`)

        if (Date.now() > start.getTime() && Date.now() < end.getTime()) {
          setAsteriEnabled(true)
          console.log('Asteri is enabled')
        }
      })
    }

    try {
      fetchAsteriConfig()
    } catch (error) {
      console.error('Error fetching Asteri config:', error)
    }
  }, [])

  const gradient = theme === 'dark' ? GRADIENT_DARK : GRADIENT_LIGHT

  const showLeaderboard = loadAds !== false && !LEADERBOARD_BLACKLIST.includes(dir)
  const showSidebar = loadAds !== false && !SIDEBAR_BLACKLIST.includes(dir)

  return (
    <>
      {artCrop && (
        <div className={styles.backgroundContainer}>
          <div
            className={styles.background}
            style={{
              backgroundImage: `${gradient}, url(${artCrop})`,
            }}
          />
        </div>
      )}
      {banner && <div className={styles.backgroundContainer}>{banner}</div>}
      <main className={styles.main}>
        {showLeaderboard && <Leaderboard />}
        <div className={classNames('d-flex flex-grow-1 p-3', { 'pe-lg-0': showSidebar })}>
          <div className='d-flex w-100'>
            <div className={showSidebar ? styles.left : 'w-100'}>{children}</div>
            {showSidebar && <div className={classNames(styles.sidebar, 'mvSidebar1')} />}
            {asteriEnabled && <AsteriAd region={asteriRegion} />}
            {twitchEnabled && <Twitch />}
          </div>
        </div>
      </main>
    </>
  )
}

export default Main
